import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { ErrorComponent } from './error';

@NgModule({
  declarations: [ErrorComponent],
  imports: [IonicModule],
  exports: [ErrorComponent]
})
export class ErrorComponentModule {}



// WEBPACK FOOTER //
// ./src/components/error/error.module.ts